import { firebase } from "../firebase/firebase";

export const itemsFetch = () => {
  return dispatch => {
    firebase
      .database()
      .ref("Item")
      .once("value", snapshot => {
        dispatch({
          type: "ITEMS_FETCH",
          payload: snapshot.val(),
        });
      });
  };
};

export const refFetch = () => {
  return dispatch => {
    firebase
      .database()
      .ref("Reference")
      .once("value", snapshot => {
        dispatch({
          type: "REFS_FETCH",
          payload: snapshot.val(),
        });
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/fetchActions.js